import React from 'react';

import { Space } from '@sravni/react-design-system';

import { useFormats } from '../../hooks/formats';
import { MenuSearch } from '../SearchBlock/components/MenuSearch';

import { MenuItem } from './components/Item';

export const FormatsMenu = () => {
  const formats = useFormats();

  return (
    <Space direction={'vertical'} size={24}>
      {formats
        .filter((format) => format.isVisible)
        .map((item) => (
          <MenuItem item={item} key={`menu-item-${item.name}`} />
        ))}
      <MenuSearch />
    </Space>
  );
};
